// TODO: Add image alt tag.
/* eslint-disable jsx-a11y/alt-text */
import { ReactNode } from 'react';
import { Container, Row, Col, Media } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import { PageComponent } from '@root/pages/Type';
import styles from './FeaturesSection.module.scss';

type FeaturesDataType = {
    key: string;
    icon: string;
    title: ReactNode;
    description: ReactNode;
};

const FeaturesSection: PageComponent = () => {
    const FeaturesData: FeaturesDataType[] = [
        {
            key: 'f1',
            icon: '/static/img/icons/thunder.svg',
            title: (
                <Trans
                    i18nKey="features.f1.title"
                    ns="landingServicesColocation"
                >
                    Elektros srovės
                </Trans>
            ),
            description: (
                <Trans
                    i18nKey="features.f1.description"
                    ns="landingServicesColocation"
                >
                    Prireikus savo dedikuotą serverį bus galima perkrauti bet
                    kokioje būsenoje (tarkim, pakibusį) ar visiškai jį išjungti.
                </Trans>
            ),
        },
        {
            key: 'f2',
            icon: '/static/img/icons/settings.svg',
            title: (
                <Trans
                    i18nKey="features.f2.title"
                    ns="landingServicesColocation"
                >
                    KVM valdymas
                </Trans>
            ),
            description: (
                <Trans
                    i18nKey="features.f2.description"
                    ns="landingServicesColocation"
                >
                    Galimybė nuotoliniu būdu tiesiogiai valdyti savo serverį
                    (matyti ekrano vaizdą, valdyti klaviaturą ir pelę - lyg
                    sėdėtumėte šalia) bei atlikti tokius veiksmus, kurių
                    negalite padaryti prisijungus nuotoliniu būdu.
                </Trans>
            ),
        },
        {
            key: 'f3',
            icon: '/static/img/icons/setup.svg',
            title: (
                <Trans
                    i18nKey="features.f3.title"
                    ns="landingServicesColocation"
                >
                    Papildomos paslaugos
                </Trans>
            ),
            description: (
                <Trans
                    i18nKey="features.f3.description"
                    ns="landingServicesColocation"
                >
                    Vietą atsarginėms duomenų kopijoms nutolusiame serveryje bei
                    kitas papildomas paslaugas serverio stebėjimo sistemą
                    informuojant SMS žinute, papildomų įrenginių prijungimus ir
                    kt.
                </Trans>
            ),
        },
        {
            key: 'f4',
            icon: '/static/img/icons/fire.svg',
            title: (
                <Trans
                    i18nKey="features.f4.title"
                    ns="landingServicesColocation"
                >
                    Apsauga
                </Trans>
            ),
            description: (
                <Trans
                    i18nKey="features.f4.description"
                    ns="landingServicesColocation"
                >
                    Busite aprupinti fizine apsauga, priesgaisrine ir
                    kondicionavimo sistema.
                </Trans>
            ),
        },

        {
            key: 'f5',
            icon: '/static/img/icons/setup.svg',
            title: (
                <Trans
                    i18nKey="features.f5.title"
                    ns="landingServicesColocation"
                >
                    Feature 5
                </Trans>
            ),
            description: (
                <Trans
                    i18nKey="features.f5.description"
                    ns="landingServicesColocation"
                >
                    Feature 5 description
                </Trans>
            ),
        },
        {
            key: 'f6',
            icon: '/static/img/icons/setup.svg',
            title: (
                <Trans
                    i18nKey="features.f6.title"
                    ns="landingServicesColocation"
                >
                    Feature 6
                </Trans>
            ),
            description: (
                <Trans
                    i18nKey="features.f6.description"
                    ns="landingServicesColocation"
                >
                    Feature 6 description
                </Trans>
            ),
        },
        {
            key: 'f7',
            icon: '/static/img/icons/setup.svg',
            title: (
                <Trans
                    i18nKey="features.f7.title"
                    ns="landingServicesColocation"
                >
                    Feature 7
                </Trans>
            ),
            description: (
                <Trans
                    i18nKey="features.f7.description"
                    ns="landingServicesColocation"
                >
                    Feature 7 description
                </Trans>
            ),
        },
        {
            key: 'f8',
            icon: '/static/img/icons/setup.svg',
            title: (
                <Trans
                    i18nKey="features.f8.title"
                    ns="landingServicesColocation"
                >
                    Feature 8
                </Trans>
            ),
            description: (
                <Trans
                    i18nKey="features.f8.description"
                    ns="landingServicesColocation"
                >
                    Feature 8 description
                </Trans>
            ),
        },
        {
            key: 'f9',
            icon: '/static/img/icons/setup.svg',
            title: (
                <Trans
                    i18nKey="features.f9.title"
                    ns="landingServicesColocation"
                >
                    Feature 9
                </Trans>
            ),
            description: (
                <Trans
                    i18nKey="features.f9.description"
                    ns="landingServicesColocation"
                >
                    Feature 9 description
                </Trans>
            ),
        },
        {
            key: 'f10',
            icon: '/static/img/icons/setup.svg',
            title: (
                <Trans
                    i18nKey="features.f10.title"
                    ns="landingServicesColocation"
                >
                    Feature 10
                </Trans>
            ),
            description: (
                <Trans
                    i18nKey="features.f10.description"
                    ns="landingServicesColocation"
                >
                    Feature 10 description
                </Trans>
            ),
        }
    ];

    return (
        <Container as="section" className={styles.section}>
            <h1 className={styles.title}>
                <Trans i18nKey="features.title" ns="landingServicesColocation">
                    Privalumai
                </Trans>
            </h1>
            <p className={styles.desc}>
                <Trans
                    i18nKey="features.description"
                    ns="landingServicesColocation"
                >
                    Jūsų nuosavo serverio patalpinimas mūsų duomenų centre su
                    papildomomis funkcijomis.
                </Trans>
            </p>

            <Row>
                {FeaturesData.map((feature) => (
                    <Col key={feature.key} sm={12} lg={6}>
                        <Media className={styles.media}>
                            <div className={styles.media_img}>
                                <div className={styles.media_img_container}>
                                    <div className={styles.media_img_inner}>
                                        <img src={feature.icon} />
                                    </div>
                                </div>
                            </div>
                            <Media.Body className={styles.media_body}>
                                <h5 className="mt-0">{feature.title}</h5>
                                <p>{feature.description}</p>
                            </Media.Body>
                        </Media>
                    </Col>
                ))}
            </Row>

        </Container>
    );
};

export default FeaturesSection;
